<script setup lang="ts">
import { Head } from "@inertiajs/vue3"

import { useNavbar } from "@/composables/useNavbar"
import { ICON } from "@/lib/icons"

const { title } = useNavbar({ title: "Sandbox" })
</script>

<template>
  <Head :title="title" />

  <div class="max-w-2xl">
    <h2 class="text-highlighted mb-2 text-lg font-semibold">UI Sandbox</h2>
    <p class="text-muted mb-6 text-sm">
      Development-only area for prototyping page designs with hardcoded data. Create new pages in
      <code class="bg-elevated rounded px-1.5 py-0.5 text-xs">pages/sandbox/</code>
      and access them at
      <code class="bg-elevated rounded px-1.5 py-0.5 text-xs">/sandbox/:page</code>.
    </p>

    <UCard>
      <div class="space-y-2">
        <a
          href="/sandbox/dashboard"
          class="text-primary flex items-center gap-2 text-sm hover:underline"
        >
          <UIcon :name="ICON.dashboard" class="size-4" />
          Dashboard prototype
        </a>
      </div>
    </UCard>
  </div>
</template>
